import React from 'react';
import local from 'services/localization/local';
import { ObservationType, Unit } from 'services/enums';
import { routePaths } from 'services/routing';
import { configIds } from 'health/observations/observation-config-ids';
import { baseObservationConfig } from 'health/observations/observation-config-helpers.jsx';
import { Thighs } from 'shared/fullColorIcons';
import LogBodyThighs from './log/LogBodyThighs';

const typeDefinition = {
  type: ObservationType.BodyThighs,
  typeUnitMap: {
    [ObservationType.BodyThighs]: Unit.Inches
  },
  unitLabelMap: {
    [Unit.Inches]: local.units.inches
  }
};

export default {
  ...baseObservationConfig,
  ...typeDefinition,
  id: configIds.bodyThighs,
  backPath: { to: routePaths.health },
  centerElement: local.observation.bodyThighs.title,
  logcenterElement: local.observation.bodyThighs.logTitle,
  noDataText: local.observation.bodyThighs.noDataText,
  iconSymbol: Thighs,
  renderLogComponent: (props) => props && <LogBodyThighs {...props} />
};
